/**
 * Module for all singleton components. To be used by services.
 * @module services/singletons
 * @preferred
 */

import sToastComponent from "@/services/sToast/sToast";
import ProgressBarComponent from '../progressBar/progressBar';
import LoaderMobileComponent from "@/services/loaderMobile/loaderMobile"

class Singletons {
  private _sToast: sToastComponent | undefined;
  private _progressBar: ProgressBarComponent | undefined;
  private _loaderMobile: LoaderMobileComponent | undefined;
  get sToast() {
    if (this._sToast) return this._sToast;
    else throw this.uninitializedError("sToast");
  }
  set sToast(sToast) {
    if (!this._sToast) this._sToast = sToast;
    else throw this.alreadyInitializedError("sToast");
  }

  get progressBar() {
    if (this._progressBar) return this._progressBar;
    else throw this.uninitializedError("progressBar");
  }

  set progressBar(progressBar) {
    if (!this._progressBar) this._progressBar = progressBar;
    else throw this.alreadyInitializedError("progressBar");
  }

  get loaderMobile() {
    if (this._loaderMobile) return this._loaderMobile;
    else throw this.uninitializedError("loaderMobile");
  }

  set loaderMobile(loaderMobile) {
    if (!this._loaderMobile) this._loaderMobile = loaderMobile;
    else throw this.alreadyInitializedError("loaderMobile");
  }

  private uninitializedError(singleton: string) {
    return new Error(
      `${singleton} not initialized. Include it in root component before use.`
    );
  }

  private alreadyInitializedError(singleton: string) {
    return new Error(
      `${singleton} already initialized. Include it once in root component.`
    );
  }
}

let singletons = new Singletons();
export default singletons;
